@if ($isSidebarExpanded()) {
  <div class="elz-flex-middle elz-flex-column">
    <div class="elz-font-size--medium elz-font--uppercase elz-margin__bottom--medium">
      Need help with anything?
    </div>
    <button
      mat-flat-button
      class="elz-margin__bottom--small"
      data-testid="knowledge-base-button"
      (click)="goToUrl(knowledgeBaseLink)"
    >
      <mat-icon>{{ localLibraryIcon }}</mat-icon>
      Knowledge Base
    </button>

    <button mat-flat-button data-testid="contact-support-button" (click)="goToUrl(helpDeskLink)">
      <mat-icon>{{ contactSupportIcon }}</mat-icon>
      Contact Support
    </button>
  </div>
} @else {
  <mat-nav-list class="elz-collapsed">
    <a mat-list-item matTooltip="Knowledge Base" [href]="knowledgeBaseLink" target="_blank">
      <mat-icon data-testid="nav-list-item-icon">
        {{ localLibraryIcon }}
      </mat-icon>
    </a>
    <a mat-list-item matTooltip="Contact Support" [href]="helpDeskLink" target="_blank">
      <mat-icon mdata-testid="nav-list-item-icon">
        {{ contactSupportIcon }}
      </mat-icon>
    </a>
  </mat-nav-list>
}
